"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = QuizTraining;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _DataStorePaths = require("../../../KESI2/Stores/DataStorePaths");

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _QuizCategories = _interopRequireDefault(require("./QuizCategories"));

var _Question = _interopRequireDefault(require("./Question2"));

var _QuizTrainingStatistic = _interopRequireDefault(require("./QuizTrainingStatistic"));

var _QuizTraining = _interopRequireDefault(require("./QuizTraining.scss"));

var _QuizStrings = require("./QuizStrings");

var _QuizOfflineHelper = _interopRequireDefault(require("./services/QuizOfflineHelper"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper.js"));

var _QuizRoundHeader = _interopRequireDefault(require("./QuizRoundHeader"));

var _QuizRound = _interopRequireDefault(require("./QuizRound.scss"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions.js"));

var _QuizSelectionService = _interopRequireDefault(require("./services/QuizSelectionService"));

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

var _Constants = require("../../constants/Constants");

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _QuizPushHelper = _interopRequireDefault(require("./services/QuizPushHelper"));

// @ts-ignore
var MAX_QUESTIONS_IN_ROW = 10;
var PAGES = {
  NONE: 'none',
  CATEGORIES: 'categories',
  PLAY: 'play',
  STATISTIC: 'statistic'
};
/**
 * Define only needed ones I guess
 */

function QuizTraining(props) {
  var _useState = (0, _react.useState)(PAGES.NONE),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      questionIndex = _useState4[0],
      setQuestionIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = (0, _react.useState)(MAX_QUESTIONS_IN_ROW),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      maxQuestions = _useState8[0],
      setMaxQuestions = _useState8[1];

  var _useDataStore = (0, _DataStore.useDataStore)(_DataStorePaths.DATA_STORE_PATHS.QD_SUBJECT_ID),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 1),
      subjectId = _useDataStore2[0]; // const [auth, setAuth] = useDataStore<string>(DATA_STORE_PATHS.QD_USER_AUTH_AUTH)


  var _useState9 = (0, _react.useState)({
    padding: 0,
    divHeight: document.body.offsetHeight - 127
  }),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      padding = _useState10[0],
      setPadding = _useState10[1];

  var _useDataStore3 = (0, _DataStore.useDataStore)(_DataStorePaths.DATA_STORE_PATHS.QD_USER_POINTS),
      _useDataStore4 = (0, _slicedToArray2["default"])(_useDataStore3, 1),
      userPoints = _useDataStore4[0];

  var _useDataStore5 = (0, _DataStore.useDataStore)(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP),
      _useDataStore6 = (0, _slicedToArray2["default"])(_useDataStore5, 1),
      userGroup = _useDataStore6[0];

  var _useDataStore7 = (0, _DataStore.useDataStore)(_DataStorePaths.DATA_STORE_PATHS.QD_CATEGORIES_OFFLINE),
      _useDataStore8 = (0, _slicedToArray2["default"])(_useDataStore7, 1),
      subjects = _useDataStore8[0];

  var _useDataStore9 = (0, _DataStore.useDataStore)(_DataStorePaths.DATA_STORE_PATHS.QD_LEARNING_STATE_OFFLINE),
      _useDataStore10 = (0, _slicedToArray2["default"])(_useDataStore9, 1),
      subjectsLearningState = _useDataStore10[0];

  var answers = (0, _react.useRef)([]);
  var processedAnswer = (0, _react.useRef)();
  var answerResults = (0, _react.useRef)([]);
  var reviewMode = (0, _react.useRef)(false);
  var questions = (0, _react.useRef)([]);
  var category = (0, _react.useRef)('');
  var answersToSend = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    props.setTitle(_config["default"].quizTrainingTitle ? _config["default"].quizTrainingTitle : 'Quiztraining');

    if (userGroup && userGroup.value && userGroup.value.questionsPerRound) {
      setMaxQuestions(userGroup.value.questionsPerRound);
    }

    function setup() {
      return _setup.apply(this, arguments);
    }

    function _setup() {
      _setup = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('quiztraining setup');
                document.addEventListener('quizPushAlert', handleMessage);
                setLoading(true);
                _context.prev = 3;
                _context.next = 6;
                return _EquizzerActions["default"].initUser();

              case 6:
                _context.next = 8;
                return _QuizOfflineHelper["default"].init(subjectId, subjectsLearningState || {});

              case 8:
                setPage(PAGES.CATEGORIES);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);
                console.error('Quiztraining, setup: ', _context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }));
      return _setup.apply(this, arguments);
    }

    setup();
    calculatePadding();
  }, []);
  (0, _react.useEffect)(function () {
    if (page === PAGES.CATEGORIES || page === PAGES.STATISTIC) {
      displayWaitingMessages();
    }

    if (page === PAGES.CATEGORIES) {
      //todo: remove when normal quiz also uses offline data
      _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_LEARNING_STATE, getLearningState(subjectsLearningState, subjectId));

      _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_CATEGORIES, getCategories(subjects, subjectId));
    }

    if (page === PAGES.PLAY && !reviewMode.current) {
      getQuestionsForCurrentCategory();
    }

    return function cleanup() {
      document.removeEventListener('quizPushAlert', handleMessage);
    };
  }, [page]);
  /*
  Dont think useEffect has the intended effect here. DataStore returns new Objects => new reference.
  React just compares references, meaning the useEffects will run after every render.
   useEffect(() => {
    DataStore.setSingleData(DATA_STORE_PATHS.QD_CATEGORIES, getCategories(subjects, subjectId))
  }, [subjects])
   useEffect(() => {
    DataStore.setSingleData(DATA_STORE_PATHS.QD_LEARNING_STATE, getLearningState(subjectsLearningState, subjectId))
  }, [subjectsLearningState])
   */

  function getCategories(subjects, subjectId) {
    if (subjects && subjectId) {
      console.log('getCategories, subjects: ', subjects);
      var subject = subjects.find(function (subject) {
        return subject.subjectId === subjectId;
      });

      if (subject) {
        return subject.rubrics;
      }
    }

    return [];
  }

  function getLearningState(subjectsLearningState, subjectId) {
    console.log('GETLEARNING STATE: ', subjectsLearningState, subjectId);

    if (subjectsLearningState && subjectId && subjectsLearningState[subjectId]) {
      return subjectsLearningState[subjectId];
    }

    return {};
  }

  function displayWaitingMessages() {
    var waitingMessages = _QuizPushHelper["default"].getAllWaitingMessages();

    if (waitingMessages.length > 0) {
      var bigMessage = '<div style="text-align:center;">';
      waitingMessages.forEach(function (message) {
        bigMessage += "".concat(message, "<br/><br/>");
      });
      bigMessage += '</div>'; // const okButton = {
      //   label: getString('OK'),
      // }

      setTimeout(function () {
        (0, _AlertHelper.showAlertWithOptions)({
          html: bigMessage,
          title: 'Neue Nachrichten',
          centeredContent: true
        });
      }, 0);

      _QuizPushHelper["default"].resetAllMessages();
    }
  }

  function handleMessage(_x) {
    return _handleMessage.apply(this, arguments);
  }

  function _handleMessage() {
    _handleMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(pushData) {
      var data;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = pushData.detail;
              console.log('singlePlayer');

              if (!(page === PAGES.PLAY)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return _QuizPushHelper["default"].storeMessage(data);

            case 5:
              _context2.next = 10;
              break;

            case 7:
              _context2.next = 9;
              return (0, _TimeoutHelper.timeout)();

            case 9:
              (0, _AlertHelper.showAlertWithOptions)({
                html: data.body,
                title: data.title,
                centeredContent: true,
                size: 'large'
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleMessage.apply(this, arguments);
  }

  function getQuestionsByIds(ids) {
    var questions = _DataStore["default"].getElementByPathImmediately(_DataStorePaths.DATA_STORE_PATHS.QD_ALL_QUESTIONS)[subjectId][category.current];

    if (!(0, _isArray["default"])(questions)) {
      throw "QuizTraining getQuestionsByIds: Unable to obtain questions ".concat(subjectId, " ").concat(questions);
    }

    return questions.filter(function (question) {
      if (ids.includes(question.id)) {
        question.learningDistance = _QuizSelectionService["default"].getHistoryForQuestion(question.id, category.current, subjectId);
        (0, _ArrayHelper.shuffle)(question.answers);
        return true;
      } else {
        return false;
      }
    });
  }

  function getQuestionsForCurrentCategory() {
    return _getQuestionsForCurrentCategory.apply(this, arguments);
  }

  function _getQuestionsForCurrentCategory() {
    _getQuestionsForCurrentCategory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var forceQuestionGroup,
          ids,
          okButton,
          goOnButton,
          _args3 = arguments;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              forceQuestionGroup = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
              _context3.prev = 1;
              _context3.next = 4;
              return _QuizSelectionService["default"].getOrderedQuestionIds(maxQuestions, category.current, subjectId, forceQuestionGroup);

            case 4:
              ids = _context3.sent;

              if (!(ids.length === 0 && !forceQuestionGroup)) {
                _context3.next = 9;
                break;
              }

              // this might be the case when we have no questions to learn
              okButton = {
                label: (0, _QuizStrings.getString)('OK'),
                callback: reset
              };
              goOnButton = {
                label: (0, _QuizStrings.getString)('PLAY'),
                callback: function callback() {
                  getQuestionsForCurrentCategory(true);
                }
              };
              return _context3.abrupt("return", (0, _AlertHelper.showAlertWithOptions)({
                html: "<p>Sie haben alle Fragen der Kategorie <b>".concat(category.current, "</b> gelernt!<p>"),
                title: 'Herzlichen Glückwunsch',
                centeredContent: true,
                buttons: [okButton, goOnButton],
                showCloseButton: false
              }));

            case 9:
              questions.current = getQuestionsByIds(ids);
              setQuestionIndex(0);
              _context3.next = 17;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3["catch"](1);
              console.error('QuizTraining: Error in getQuestionsForCurrentCategory ', _context3.t0);
              reset();

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 13]]);
    }));
    return _getQuestionsForCurrentCategory.apply(this, arguments);
  }

  function onSetCategory(categoryName) {
    category.current = categoryName;
    setPage(PAGES.PLAY);
  }

  function reset() {
    answers.current = [];
    answerResults.current = [];
    questions.current = [];
    category.current = '';
    setQuestionIndex(-1);
    setPage(PAGES.CATEGORIES);
  }

  function saveAnswer(_x2, _x3, _x4) {
    return _saveAnswer.apply(this, arguments);
  }

  function _saveAnswer() {
    _saveAnswer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(selectedAnswerProcessed, selectedAnswer, correct) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              console.log('saveAnswer', selectedAnswerProcessed, selectedAnswer, correct);
              answers.current.push(selectedAnswer);
              processedAnswer.current = selectedAnswerProcessed;
              answerResults.current.push({
                isCorrect: correct,
                score: selectedAnswerProcessed.score
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _saveAnswer.apply(this, arguments);
  }

  function goToNextQuestion() {
    return _goToNextQuestion.apply(this, arguments);
  }

  function _goToNextQuestion() {
    _goToNextQuestion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var isLastQuestion, cur_category, feedbackHiddenByGroup, path, answersForServer, auth;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              isLastQuestion = false;
              cur_category = category.current;

              if (questionIndex === maxQuestions - 1 || questionIndex === questions.current.length - 1) {
                isLastQuestion = true;
                feedbackHiddenByGroup = _DataStore["default"].getElementByPathImmediately(_DataStorePaths.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

                _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_SINGLE_PLAYER_QUESTION_INDEX, 0);

                if (feedbackHiddenByGroup) {
                  reset();
                } else {
                  setPage(PAGES.STATISTIC);
                  setQuestionIndex(-1);
                }
              } else {
                setQuestionIndex(questionIndex + 1);

                _DataStore["default"].setSingleData(_DataStorePaths.DATA_STORE_PATHS.QD_SINGLE_PLAYER_QUESTION_INDEX, questionIndex + 1);
              }

              if (!(processedAnswer && processedAnswer.current)) {
                _context5.next = 6;
                break;
              }

              _context5.next = 6;
              return addAnswerToQueue({
                value: processedAnswer.current.value,
                factor: processedAnswer.current.factor,
                score: processedAnswer.current.score
              });

            case 6:
              if (!isLastQuestion) {
                _context5.next = 21;
                break;
              }

              path = "".concat(_DataStorePaths.DATA_STORE_PATHS.QD_ANSWERS_OFFLINE, ".").concat(subjectId);
              answersForServer = (0, _toConsumableArray2["default"])(answersToSend.current);
              _context5.next = 11;
              return _DataStore["default"].setSingleData(path, answersForServer);

            case 11:
              _context5.next = 13;
              return _QuizSelectionService["default"].updateLearningState(cur_category, subjectId);

            case 13:
              _context5.t0 = "Bearer ";
              _context5.next = 16;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 16:
              _context5.t1 = _context5.sent;
              auth = _context5.t0.concat.call(_context5.t0, _context5.t1);
              _context5.next = 20;
              return _QuizOfflineHelper["default"].sendAnswersToServer(auth, subjectId);

            case 20:
              answersToSend.current = [];

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _goToNextQuestion.apply(this, arguments);
  }

  function addAnswerToQueue(_x5) {
    return _addAnswerToQueue.apply(this, arguments);
  }

  function _addAnswerToQueue() {
    _addAnswerToQueue = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(answer) {
      var toSend;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              toSend = {
                questionId: questions.current[questionIndex].id,
                rubric: category.current,
                answer: answer,
                countPoints: userPoints,
                affectLearnState: true
              };
              answersToSend.current.push(toSend); // todo: check if it affects learnstate?

              _context6.next = 4;
              return _QuizSelectionService["default"].updateQuestionHistory(subjectId, category.current, questions.current[questionIndex], answer.score > 0);

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return _addAnswerToQueue.apply(this, arguments);
  }

  function goToAnswer(index) {
    setQuestionIndex(index);
    reviewMode.current = true;
    setPage(PAGES.PLAY);
  }

  function goToStatistic() {
    setQuestionIndex(-1);
    reviewMode.current = false;
    setPage(PAGES.STATISTIC);
  }

  function sortCategories() {
    var _categories = getCategories(subjects, subjectId);

    if (_categories) {
      _categories.sort(function (category1, category2) {
        if (category1.activeFrom && category2.activeFrom) {
          if (category1.activeFrom < category2.activeFrom) {
            return -1;
          } else if (category1.activeFrom >= category2.activeFrom) {
            return 1;
          } else {
            return 0;
          }
        } else {
          if (category1.name < category2.name) {
            return -1;
          } else if (category1.name >= category2.name) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    }
  }

  function calculatePadding() {
    var height;
    var width;

    if (_DeviceInfoHelper["default"].isBrowser()) {
      height = window.innerHeight;
      width = window.innerWidth;
    } else {
      // height = this.props.sidebarDocked ? Math.min(window.screen.availHeight, window.screen.availWidth) : Math.max(window.screen.availHeight, window.screen.availWidth)
      height = props.sidebarDocked ? Math.min(window.innerHeight, window.innerWidth) : Math.max(window.innerHeight, window.innerWidth); // const width = this.props.sidebarDocked ? Math.max(window.screen.availHeight, window.screen.availWidth) - MAIN_MENU_WIDTH : Math.min(window.screen.availHeight, window.screen.availWidth)

      width = props.sidebarDocked ? Math.max(window.innerHeight, window.innerWidth) - _Constants.MAIN_MENU_WIDTH : Math.min(window.innerHeight, window.innerWidth);
    }

    var perfectWidth = height / _Constants.PERFECT_RATIO + 30;
    setPadding({
      padding: (width - perfectWidth) / 2,
      divHeight: document.body.offsetHeight - 127
    });
  }

  function getComponentToRender() {
    if (page === PAGES.NONE) {
      return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
    }

    if (page === PAGES.CATEGORIES && subjects) {
      sortCategories();
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          overflow: 'scroll',
          height: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement(_QuizCategories["default"], {
        setTitle: props.setTitle,
        onSetCategory: onSetCategory,
        showSpinner: false,
        trainingMode: true,
        hideLearningState: false
      }));
    } else if (page === PAGES.PLAY && questions.current && questions.current.length > 0 && questions.current[questionIndex]) {
      var currentQuestion = questions.current[questionIndex];

      if (!currentQuestion.number) {
        currentQuestion.number = questionIndex;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '94%',
          margin: '0 auto',
          height: '100%',
          overflow: 'scroll'
        }
      }, /*#__PURE__*/_react["default"].createElement(_QuizRoundHeader["default"], {
        className: _QuizRound["default"].quizHeader,
        userState: {},
        questions: questions,
        opponent: {},
        questionsPerRound: questions.current.length > maxQuestions ? maxQuestions : questions.current.length,
        styles: {},
        user: {},
        answers: answers,
        answerResults: answerResults,
        isSinglePlayer: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTraining["default"].questionContainer,
        style: {
          maxHeight: "".concat(padding.divHeight, "px"),
          height: '100%',
          overflow: 'hidden'
        },
        id: 'questionContainer'
      }, /*#__PURE__*/_react["default"].createElement(_Question["default"], {
        key: questionIndex,
        question: currentQuestion,
        sequences: {},
        onSubmitAnswer: goToNextQuestion,
        isSinglePlayer: true,
        saveAnswer: saveAnswer,
        reviewMode: reviewMode.current,
        selectedAnswers: reviewMode.current ? answers.current[questionIndex] : null,
        disableTimer: true,
        parentDomId: 'questionContainer',
        goToStatistic: goToStatistic,
        reducePointsOnError: userGroup.value.reducePointsOnError || false
      })));
    } else if (page === PAGES.STATISTIC) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '94%',
          margin: '0 auto',
          height: '100%',
          overflow: 'scroll'
        }
      }, /*#__PURE__*/_react["default"].createElement(_QuizTrainingStatistic["default"], {
        goHome: reset,
        goToAnswer: goToAnswer,
        answers: answerResults.current,
        percentageCorrect: userGroup.value.percentageCorrect || 0,
        reducePointsOnError: userGroup.value.reducePointsOnError || false
      }));
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _QuizTraining["default"].mainContainer
  }, getComponentToRender());
}